import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { CommunicationPhoneLogResponseDto, CommunicationPermissionDto } from "@src/api-new/generated-api.schemas";

import type { SubmitUpdatePasswordFormPayload } from "./Account.types";

interface AccountState {
  communicationPreferences?: Partial<CommunicationPermissionDto>,
  commPhoneLogs?: CommunicationPhoneLogResponseDto[]
}

const initialState: AccountState = {};

const accountSlice = createSlice({
  name: "account",
  initialState,
  reducers: {
    getCommunicationPreferences(state, action: PayloadAction<CommunicationPermissionDto | undefined>) {
      state.communicationPreferences = action.payload;
    },
    changeCommunicationPrefences(state, action: PayloadAction<Partial<CommunicationPermissionDto>>) {
      return state;
    },
    changePhoneNumber(state) {
      return state;
    },
    getCommunicationPhoneLogsRequest(state) {
      return state;
    },
    getCommunicationPhoneLogsSuccess(state, action: PayloadAction<CommunicationPhoneLogResponseDto[]>) {
      state.commPhoneLogs = action.payload;
    },
    submitUpdatePasswordForm(state, action: PayloadAction<SubmitUpdatePasswordFormPayload>) {
      return state;
    },
    destroy() {
      return initialState;
    }
  }
});


export default accountSlice.reducer;
export const {
  getCommunicationPreferences,
  changeCommunicationPrefences,
  changePhoneNumber,
  getCommunicationPhoneLogsRequest,
  getCommunicationPhoneLogsSuccess,
  submitUpdatePasswordForm,
  destroy
} = accountSlice.actions;
export const accountActions = accountSlice.actions;
